// @ts-nocheck
import { GetOrdersApiParameter } from "@insite/client-framework/Services/OrderService";
import { createHandlerChainRunner, Handler } from "@toolkit/Modules/client-framework/HandlerCreator";

type HandlerType = Handler<GetOrdersApiParameter>;

export const DispatchUpdateDraftParameter: HandlerType = props => {
    props.dispatch({
        type: "Greif/Pages/OrderHistory/UpdateDraftParameter",
        parameter: props.parameter,
    });
};

export const chain = [DispatchUpdateDraftParameter];

const updateDraftParameter = createHandlerChainRunner(chain, "UpdateDraftParameter");
export default updateDraftParameter;
